// EL PANEL FILTRABA POR UN MES Y ESCONDÍA LOS TRIMESTRES.
//
// Hasta la mig 315 una suscripción cubría UN mes, así que `period_month` era a
// la vez "cuándo empieza" y "de qué mes es", y la columna «Mes» y su filtro
// decían la verdad. Con `term_months` ya no: los siete trimestres del pack
// tienen `period_month` octubre y ocupan plaza hasta el 31 de diciembre. La
// tabla los pintaba como `10/2026` y el filtro «12/2026» no los encontraba —
// justo cuando lo que se quiere saber es quién está dentro ese mes.
//
// Este fichero NO comparte código con el de la app: allí la etiqueta es
// «Octubre – Diciembre 2026» para un socio y aquí `10–12/2026` para una tabla
// densa. Lo único que se repetiría es el nombre de los meses, y aquí no se usa.

/** `term_months` saneado: la BD lo tiene NOT NULL DEFAULT 1 con CHECK 1..12. */
function meses(termMonths: number | null | undefined): number {
  return Math.max(1, Math.trunc(termMonths ?? 1));
}

/** `MM/YYYY` de un `period_month` (1º de mes, `YYYY-MM-DD`). */
export function fmtMonth(d: string | null): string {
  if (!d) return '—';
  const [y, m] = d.split('-');
  return `${m}/${y}`;
}

// Lo que cubre el término: `10/2026` para un mes, `10–12/2026` dentro del año,
// `12/2026–02/2027` cuando lo cruza.
export function fmtTermino(
  periodMonth: string | null,
  termMonths: number | null | undefined
): string {
  if (!periodMonth) return '—';
  const n = meses(termMonths);
  if (n === 1) return fmtMonth(periodMonth);
  const cubiertos = mesesDelTermino(periodMonth, termMonths);
  const fin = cubiertos[cubiertos.length - 1];
  const [y] = periodMonth.split('-');
  const [yFin, mFin] = fin.split('-');
  return yFin === y
    ? `${periodMonth.split('-')[1]}–${mFin}/${y}`
    : `${fmtMonth(periodMonth)}–${fmtMonth(fin)}`;
}

// Todos los meses que cubre el término, como `YYYY-MM-01`. Es lo que necesita el
// filtro: un trimestre de octubre tiene que aparecer al filtrar por noviembre y
// por diciembre, porque en esos meses el jugador ocupa su plaza.
export function mesesDelTermino(
  periodMonth: string | null,
  termMonths: number | null | undefined
): string[] {
  if (!periodMonth) return [];
  const [y, m] = periodMonth.split('-').map(Number);
  if (!y || !m) return [];
  const salida: string[] = [];
  for (let i = 0; i < meses(termMonths); i++) {
    const idx = m - 1 + i;
    const yy = y + Math.floor(idx / 12);
    const mm = String((idx % 12) + 1).padStart(2, '0');
    salida.push(`${yy}-${mm}-01`);
  }
  return salida;
}
